import React, { Component } from 'react';
import { GenericInputValidate, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';
import PopOverLimit from './PopOverLimit.jsx';

let mensaje = null;

class InputLimiteCompra extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAlert: false,
        };
        this.changeInput = this.changeInput.bind(this);
    }

    changeInput(event) {
        this.props.changeInput("LIMITE_COMPRA", event.target.value.replace(/\./g, ''));
    }

    ShowAlert(event) {
        this.setState({ showAlert: true });
    }

    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;

        if (!this.props.data.edicion) {
            errorContainer = <label className="error">
                {(errors = getFieldError('inputPurchase')) ? errors.join(',') : null}</label>
        } else {
            errorContainer = <label className="error">
                {(errors = getFieldError('inputPurchase')) ?
                    this.props.form.isFieldTouched("inputPurchase") ?
                        errors.join(',') : null
                    : null}</label>
        }

        const { clienteResultadoBusqueda, empresas, novedadesEmpresas } = this.props.tarjetas;

        let enterpriseNodes;
        let limitesCliente;
        let limiteGlobalSinAsignar = 0;
        let limiteClienteEliminacionDecimales;
        let LimitPurchase = 0;

        if (this.props.tarjetas && this.props.tarjetas != "") {
            limitesCliente = GlobalHelper.ObtenerLimitesEmpresaCliente(empresas, novedadesEmpresas, clienteResultadoBusqueda);

            enterpriseNodes = empresas.map((row) => {
                let limiteNovedad;
                let novedad = novedadesEmpresas.find(x => x.EmpresaVisaId == row.Id);

                if (novedad) {
                    limiteNovedad = novedad.valorNovedadFormato;
                }
                else {
                    limiteNovedad = row.limiteCompraFormato;
                }

                return (
                    <PopOverLimit key={row.Id.toString()} Descripcion={row.Descripcion} LimiteCompra={limiteNovedad} />
                );
            });

            this.props.data.AlertMessage = ((limitesCliente.LimitePorCuit - limitesCliente.LimiteAsignado) < this.props.data.LimitPurchase)

            LimitPurchase = GlobalHelper.ConvertirNumeroMilesMillones(this.props.data.LimitPurchase);
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-primary">Límite de Compra</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-4">

                            <GenericInputValidate
                                getFieldProps={getFieldProps('inputPurchase', {
                                    onChange(e) {
                                        me.changeInput(e);
                                    },
                                    rules: [{
                                        required: true,
                                        pattern: /^[0-9.]+$/,
                                        message: 'Debe ingresar un valor válido.'
                                    }]
                                })}
                                id="inputPurchase"
                                name="inputPurchase"
                                value={LimitPurchase}
                                className="form-control default-input"
                                maxLength="13"
                            />
                            {errorContainer}
                            {(this.props.data.AlertMessage && this.props.tarjetas.clienteResultadoBusqueda.Id > 0) ?
                                <div>
                                    <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }}>
                                    </span> El valor que ingresó eleva la sumatoria de los límites
                                    <br /> de las empresas por sobre el global. Por favor, al finalizar la creación de la empresa
                                    <br /> recuerde usar la opción "Distribuir límites" para solucionarlo
                                 </div> :
                                null}
                        </div>
                    </div>
                    <div className="dropdown">
                        <button className="btn-link btn-link-secondary" data-toggle="dropdown">Ver los límites actuales</button>
                        <ul className="dropdown-menu dropdown-menu-md">
                            <div className="row">
                                <a href="javascript:void(0)"><span className="ti-close dropdown-closable-button" /></a>
                                <div className="col-xs-12">
                                    <div className="row top-separator-xxs">
                                        <div className="col-xs-12">
                                            <h4>Distribución actual de límites</h4>
                                        </div>
                                    </div>
                                    <div className="row top-separator-xxs bottom-separator">
                                        <div className="col-xs-8">
                                            <span className="fa fa-money"></span><label className="label-primary">&nbsp; Límite global total para {this.props.data.Administrator}:</label>
                                        </div>
                                        <div className="col-xs-4">
                                            <label className="label-primary">${GlobalHelper.FormatearLimite(limitesCliente.LimitePorCuit)}</label>
                                        </div>
                                    </div>
                                    <div className="row top-separator-xxs">
                                        <div className="col-xs-12">
                                            {enterpriseNodes}
                                        </div>
                                    </div>
                                    <div className="row top-separator-xxs top-separator">
                                        <div className="col-xs-8">
                                            <span className="icon-available-limit22"></span><label className="label-primary">&nbsp; Límite global sin asignar:</label>
                                        </div>
                                        <div className="col-xs-4">
                                            <label className="label-primary">${GlobalHelper.FormatearLimite(limitesCliente.LimiteSinAsignar)}</label>
                                        </div>
                                    </div>
                                    <div className="row top-separator-xxs">
                                        <div className="col-xs-12">
                                            <h6>Puede definir ahora un límite inconsistente con esta distribución y hacer luego las correcciones necesarias con la opción "Distribuir límites".
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                    </div>
                </div>
            </div >
        );
    }
};

export default InputLimiteCompra;